<div class="training-form">
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <div class="training-status-wrapper">
        <dx-radio-group
          *ngIf="canShowRadioGroup"
          [readOnly]="isViewMode"
          [items]="trainingStatusOption"
          [value]="
            trainingForm.isDeployed
              ? trainingStatusOption[1]
              : trainingStatusOption[0]
          "
          (valueChange)="
            trainingForm.isDeployed = $event === trainingStatusOption[1]
          "
          layout="horizontal"
        >
        </dx-radio-group>
        <dx-button
          *ngIf="!isViewMode"
          text="{{ 'COMMON.SAVE' | translate }}"
          type="normal"
          (click)="onFormSubmitClick()"
        >
        </dx-button>
        <ng-container *ngIf="primaryButton && isViewMode">
          <dx-drop-down-button
            [splitButton]="true"
            [text]="primaryButtonText"
            stylingMode="contained"
            type="normal"
            [dropDownOptions]="{ width: 230 }"
            [items]="menuActions"
            (onButtonClick)="onPrimaryButtonClick()"
            (onItemClick)="onMenuItemClick($event)"
            displayExpr="name"
            keyExpr="id"
          ></dx-drop-down-button>
        </ng-container>
      </div>
    </div>
    <app-page-title
      [title]="
        isViewMode
          ? ('TRAINING.TITLE-VIEW' | translate)
          : editingTrainingId
          ? ('TRAINING.TITLE-EDIT' | translate)
          : ('TRAINING.TITLE-ADD' | translate)
      "
    ></app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="avatar-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="user-avatar"
              [src]="trainingForm.imageBase64"
              *ngIf="trainingForm.imageBase64"
            />
            <img
              class="user-avatar"
              src=""
              appTrainingImageFallback
              *ngIf="!trainingForm.imageBase64 && editingTrainingId"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!trainingForm.imageBase64 && !editingTrainingId"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description-drag">{{
                "COMMON.UPLOAD-DRAG-DROP" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useButtons"
            [visible]="false"
            (valueChange)="onAvatarUploaded($event)"
            [readOnly]="isViewMode"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel
          class="training-panel"
          [title]="
            isViewMode ? ('TRAINING.FORM.TITLE-DESCRIPTION' | translate) : null
          "
        >
          <dx-form
            #descriptionForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="trainingForm"
            [readOnly]="isViewMode"
          >
            <dxi-item
              *ngIf="!isViewMode && !editingTrainingId"
              dataField="templateId"
            >
              <div *dxTemplate>
                <dx-drop-down-box
                  #templateDropDown
                  [(value)]="trainingForm.templateId"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.TRAINING-TEMPLATE' | translate"
                  [dataSource]="templates"
                  labelMode="floating"
                  stylingMode="outlined"
                  (onValueChanged)="templateDropDown.instance.close()"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="templates"
                      keyExpr="id"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      (onItemClick)="onTrainingTemplateSelected($event)"
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
            <dxi-item dataField="name">
              <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.TITLE-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{
                height: 100
              }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
            <dxi-item *ngIf="displayEventKey && isViewMode && training">
              <div *dxTemplate>
                <div class="training-key-container">
                  <div class="training-key-label">ID:</div>

                  <div 
                    class="training-key-wrapper" 
                    (click)="copyTrainingKey(training.training.key)"
                  >
                    <div class="training-key-text">
                      {{ training.training.key }}
                    </div>

                    <button 
                      mat-icon-button 
                      class="training-key-copy" 
                    >
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-panel [title]="'TRAINING.FORM.DATE-TIME' | translate">
          <div *ngIf="!isViewMode">
            <app-training-date-selection
              #trainingDateSelection
              (startDateChanged)="onStartDateChanged($event)"
              [onlyFutureDatesAllowed]="!editingTrainingId"
              (onFutureDateCheck)="onFutureDateCheck($event)"
            ></app-training-date-selection>
          </div>
          <div *ngIf="isViewMode && training">
            <div
              *ngFor="let date of training!.dates"
              class="training-date-block"
            >
              <div>
                <div
                  *ngIf="areDatesOnSameDay(date.start, date.end)"
                  class="training-date-block-date"
                >
                  {{
                    date.start
                      | date
                        : "EEEE, dd LLLL yyyy"
                        : ""
                        : translateService.currentLang
                  }}
                </div>
                <div
                  *ngIf="!areDatesOnSameDay(date.start, date.end)"
                  class="training-date-block-date"
                >
                  {{
                    date.start
                      | date
                        : "EEEE, dd LLLL yyyy"
                        : ""
                        : translateService.currentLang
                  }}
                  -
                  {{
                    date.end
                      | date
                        : "EEEE, dd LLLL yyyy"
                        : ""
                        : translateService.currentLang
                  }}
                </div>
                <span
                  *ngIf="translateService.currentLang == 'en'"
                  class="training-date-block-time"
                >
                  {{ date.start | date : "hh:mm a" }} -
                  {{ date.end | date : "hh:mm a" }}
                </span>
                <span
                  *ngIf="translateService.currentLang == 'de'"
                  class="training-date-block-time"
                >
                  {{ date.start | date : "HH:mm" }} -
                  {{ date.end | date : "HH:mm" }}
                </span>
              </div>
              @if (!isExternalEvent) {
                <div 
                  *ngIf="training.status !== 2" 
                  class="training-date-block-employee"
                >
                  <div
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Accepted)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ allAcceptedMembersCount }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{ "COMMON.FIELDS.EMPLOYEE-STATUSES.ACCEPTED" | translate }}
                    </div>
                  </div>
                  <div class="training-date-block-employee-separator"></div>
                  <div
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Open)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ openMembers.length }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{ "COMMON.FIELDS.EMPLOYEE-STATUSES.OPEN" | translate }}
                    </div>
                  </div>
                  <div class="training-date-block-employee-separator"></div>
                  <div
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Declined)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ allDeclinedMembersCount }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{ "COMMON.FIELDS.EMPLOYEE-STATUSES.DECLINED" | translate }}
                    </div>
                  </div>
                  <div
                    class="training-date-block-employee-separator"
                    *ngIf="requestedMembers.length > 0"
                  ></div>
                  <div
                    *ngIf="requestedMembers.length > 0"
                    class="training-date-block-employee-stats-danger"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Requested)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ allRequestedMembersCount }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{
                        "COMMON.FIELDS.EMPLOYEE-STATUSES.REQUESTED" | translate
                      }}
                    </div>
                  </div>
                  <div
                    class="training-date-block-employee-separator"
                    *ngIf="queueMembers.length > 0"
                  ></div>
                  <div
                    *ngIf="queueMembers.length > 0"
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Queue)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ allQueueMembersCount }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{
                        "COMMON.FIELDS.EMPLOYEE-STATUSES.QUEUE" | translate
                      }}
                    </div>
                  </div>
                  <div 
                    *ngIf="training && !training.isFromSubscribedSource"
                    class="training-date-block-employee-separator"
                  ></div>
                  <div
                    *ngIf="training && !training.isFromSubscribedSource"
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.ByChannel)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ channelMembersCount }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{
                        "COMMON.FIELDS.CHANNEL" | translate
                      }}
                    </div>
                  </div>
                </div>
                <div 
                  *ngIf="training.status === 2" 
                  class="training-date-block-employee"
                >
                  <div
                    class="training-date-block-employee-stats"
                    (click)="showEmployeeModal(EmployeeStatusTabs.Completed)"
                  >
                    <div class="training-date-block-employee-count">
                      {{ completedMembers.length }}
                    </div>
                    <div class="training-date-block-employee-status">
                      {{ "COMMON.FIELDS.EMPLOYEE-STATUSES.COMPLETED" | translate }}
                    </div>
                  </div>
                  @if(allAcceptedMembersCount > 0) {
                    <div class="training-date-block-employee-separator"></div>
                    <div
                      class="training-date-block-employee-stats"
                      (click)="showEmployeeModal(EmployeeStatusTabs.NoShows)"
                    >
                      <div class="training-date-block-employee-count">
                        {{ allAcceptedMembersCount }}
                      </div>
                      <div class="training-date-block-employee-status">
                        {{ "COMMON.FIELDS.EMPLOYEE-STATUSES.NO-SHOWS" | translate }}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </app-panel>
      </div>
    </div>
    <div>
      <app-panel>
        <dx-tabs
          width="100%"
          [selectedIndex]="selectedDescriptionTab"
          [showNavButtons]="false"
          [dataSource]="descriptionTabs"
          (onItemClick)="onDescriptionTabChange($event)"
        ></dx-tabs>
        <div 
          class="training-description-wrapper"
          *ngIf="selectedDescriptionTab == 0"
        >
          <app-expandable-text-editor
            [readOnly]="isViewMode"
            [(value)]="trainingForm.descriptionExtended"
            [(isExpanded)]="isDescriptionExpanded"
          ></app-expandable-text-editor>
          <div 
            *ngIf="userContext.canUseTextTemplates"
            class="text-template-container"
          >
            <app-text-template-selector
              *ngIf="!isViewMode"
              [type]="descriptionTextTemplateType"
              [content]="trainingForm.descriptionExtended"
              (contentChange)="onTemplateContentChanged($event)"
            ></app-text-template-selector>
          </div>
        </div>
        <div 
          class="training-description-wrapper"
          *ngIf="selectedDescriptionTab == 1"
        >
          <app-expandable-text-editor
            [readOnly]="isViewMode"
            [(value)]="trainingForm.descriptionCertificate"
            [(isExpanded)]="isCertificateDescriptionExpanded"
            [fontFamily]="certificateFontFamily"
            [fontSize]="certificateFontSize"
          >
            <div editor-extra-actions class="extra-actions">
              <dx-button
                [text]="'COMMON.CERTIFICATE-PREVIEW' | translate"
                class="preview-button"
                (click)="showCertificatePreview()"
              ></dx-button>
            </div>
          </app-expandable-text-editor>
          <dx-form
            class="legal-footer"
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="trainingForm"
            [readOnly]="isViewMode"
          >
            <dxi-item itemType="group" colCount="2">
              <dxi-item *ngIf="!isViewMode">
                <div *dxTemplate>
                  <app-organisation-unit-footer-selector
                    [label]="'TRAINING.FORM.CHOOSE-LEGAL-FOOTER-LOCATION' | translate"
                    [data]="certificateOrganizationUnits"
                    [(value)]="trainingForm.certificateFooterLocationId">
                  </app-organisation-unit-footer-selector>
                </div>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </div>
      </app-panel>
    </div>
    <div>
      <app-panel [title]="'TRAINING.FORM.TRAINING-SETTINGS' | translate">
        <dx-form
          #settingsForm
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="trainingForm"
          [readOnly]="isViewMode"
        >
          <dxi-item itemType="group">
            <dxo-col-count-by-screen
              [xs]="1"
              [sm]="1"
              [md]="1"
              [lg]="2"
            ></dxo-col-count-by-screen>
            <dxi-item itemType="group">
              <dxi-item *ngIf="!isExternalEvent">
                <dxo-label
                  [text]="'COMMON.FIELDS.TRAINERS' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="trainingForm.trainerIds"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMMON.FIELDS.TRAINERS' | translate"
                    [dataSource]="trainers"
                    [readOnly]="isViewMode"
                    labelMode="floating"
                    stylingMode="outlined"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="trainers"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onTrainerSelected($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
              <dxi-item
                [editorOptions]="trainingTypeOptions"
                dataField="trainingType"
                editorType="dxSelectBox"
                [editorOptions]="{ showClearButton: true }"
              >
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.TRAINING-TYPE-REQUIRED' | translate"
                ></dxi-validation-rule>
                <dxo-label
                  [text]="'COMMON.FIELDS.TRAINING-TYPE' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item *ngIf="trainingForm.trainingType === TrainingTypeModel.IDD">
                <div *dxTemplate>
                  <div>
                    <dx-validator
                      [adapter]="trainingTimeAdapter"
                      validationGroup="trainingTimeGroup"
                    >
                      <dxi-validation-rule
                        type="custom"
                        [validationCallback]="validateTrainingTime"
                        [message]="
                          'VALIDATIONS.TRAINING-TIME-MINUTE' | translate
                        "
                      ></dxi-validation-rule>
                      <dx-validation-summary></dx-validation-summary>
                    </dx-validator>
                    <div #timePicker>
                      <app-time-picker
                        [isInvalid]="!isTrainingTimeValid"
                        [label]="'COMMON.FIELDS.TRAINING-TIME' | translate"
                        [disabled]="isViewMode"
                        (timeChanged)="handleTimePicker($event)"
                        [defaultValue]="{
                          hours: trainingForm.iddHours!,
                          minutes: trainingForm.iddMinutes!
                        }"
                        [validationMessage]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
                      ></app-time-picker>
                    </div>
                  </div>
                </div>
              </dxi-item>
              <dxi-item 
                *ngIf="!isExternalEvent"
                dataField="maximumMembers" 
                editorType="dxNumberBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.MAXIMUM-PARTICIPANTS' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="trainingForm.trainingType === TrainingTypeModel.IDD && isWbdConfigured"
                [editorOptions]="learningTypeOptions"
                dataField="lernart"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.LEARNING-TYPE' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LEARNING-TYPE-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>

              <dxi-item
                *ngIf="trainingForm.trainingType === TrainingTypeModel.IDD && isWbdConfigured"
                [editorOptions]="learningContentOptions"
                dataField="lerninhalt"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.LEARNING-CONTENT' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LEARNING-CONTENT-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item *ngIf="!isExternalEvent">
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="trainingForm.reminders"
                    [inputAttr]="{ 'aria-label': 'Owner' }"
                    [dataSource]="reminderOptions"
                    [label]="'COMMON.FIELDS.TRAINING-CONFIRMATION-AND-REMINDERS' | translate"
                    valueExpr="value"
                    displayExpr="label"
                    [readOnly]="isViewMode"
                    labelMode="floating"
                    stylingMode="outlined"
                    [showClearButton]="true"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="false"
                        [dataSource]="reminderOptions"
                        dataStructure="plain"
                        keyExpr="value"
                        displayExpr="label"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onReminderSelectionChanged($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
              <dxi-item>
                <div *dxTemplate>
                  <hr>
                  <div class="publication-mode-container">
                    <app-publication-mode-selection
                      [mode]="trainingForm.publishingMode"
                      (modeChange)="onPublishingModeChanged($event)"
                      [isViewMode]="isViewMode"
                      [isPublishedToSubscribers]="isTenantPublishedToSubscribers"
                      [isPrivatePublishing]="isPrivatePublishing"
                    ></app-publication-mode-selection>
                  </div>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item>
              <div *dxTemplate>
                <app-event-publication-settings
                  [publishingMode]="trainingForm.publishingMode"
                  [isPublishedToSubscribers]="isTenantPublishedToSubscribers"
                  [isPrivatePublishing]="isPrivatePublishing"
                  [isViewMode]="isViewMode"
                  [personCount]="personCount"

                  [visibilityMode]="trainingForm.visibilityMode"
                  (visibilityModeChange)="onVisibilityModeChanged($event)"

                  [(selectedOrganizationUnitIds)]="selectedOrganizationUnitIds"

                  [allowSharingWithSubscribers]="trainingForm.allowSharingWithSubscribers"
                  (allowSharingWithSubscribersChange)="
                    onAllowSharingWithSubscribersChanged($event)
                  "

                  [(trainingGroupIds)]="trainingForm.trainingGroupIds"
                  [(trainingCategoryIds)]="trainingForm.trainingCategoryIds"
                  [(standardTrainingCategoryIds)]="trainingForm.standardTrainingCategoryIds"
                  [(roleIds)]="trainingForm.roleIds"
                  [(subscriptionIds)]="trainingForm.subscriptionIds"

                  [organizationUnits]="organizationUnits"
                  [trainingGroups]="trainingGroups"
                  [trainingCategories]="trainingCategories"
                  [standardTrainingCategories]="standardTrainingCategories"
                  [usedStandardTrainingCategories]="usedStandardTrainingCategories"
                  [roles]="roles"
                  [subscribers]="subscribers"
                ></app-event-publication-settings>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
        <div class="row checkboxes-row">
          <div class="col-12">
            <dx-form
              [colCountByScreen]="{ lg: 2, md: 1 }"
              [formData]="trainingForm"
              [showColonAfterLabel]="false"
              labelMode="static"
              [readOnly]="isViewMode"
            >
              <dxi-item
                *ngIf="!isExternalEvent"
                dataField="sendCertificateLink"
                editorType="dxCheckBox"
                [editorOptions]="{
                  text: 'COMMON.FIELDS.CERTIFICATE-LINK-IN-COMPLETION-MAIL' | translate,
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="!isExternalEvent"
                dataField="sendFeedbackLink"
                editorType="dxCheckBox"
                [editorOptions]="{
                  text: 'COMMON.FIELDS.FEEDBACK-LINK-IN-COMPLETION-MAIL' | translate,
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="!isExternalEvent"
                dataField="allowUnknownUsersToJoin"
                editorType="dxCheckBox"
                [editorOptions]="{
                  text: 'COMMON.FIELDS.ALLOW-UNKNOWN-USERS-TO-JOIN' | translate,
                  disabled: allowUnknownUsersToJoinDisabled
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
            </dx-form>
          </div>
        </div>
      </app-panel>
    </div>
    <div>
      <app-panel
        class="training-location-panel"
        [title]="'COMMON.FIELDS.TRAINING-LOCATION' | translate"
      >
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <dx-form
              #locationForm
              [formData]="trainingForm"
              [showColonAfterLabel]="false"
              labelMode="floating"
              [readOnly]="
                isViewMode || 
                (!!editingTrainingId && isIntegrationLocationType)
              "
            >
              <dxi-item
                [editorOptions]="trainingLocationTypeOptions"
                dataField="trainingLocation.locationType"
                editorType="dxSelectBox"
              >
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.EVENT-TYPE-REQUIRED' | translate"
                ></dxi-validation-rule>

                <dxo-label
                  [text]="'COMMON.FIELDS.EVENT-TYPE' | translate"
                ></dxo-label>
              </dxi-item>

              <dxi-item
                *ngIf="
                  trainingForm.trainingLocation.locationType ===
                  TrainingLocationType.Address
                "
              >
                <div *dxTemplate>
                  <dx-validator
                    [adapter]="trainingLocationAdapter"
                    validationGroup="trainingLocationGroup"
                  >
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                    <dx-validation-summary></dx-validation-summary>
                  </dx-validator>

                  <div #googleAutocomplete>
                    <dx-autocomplete
                      [(text)]="googleSearchText"
                      [searchExpr]="autocompleteSearchFilter"
                      [label]="'TRAINING.FORM.SEARCH-TRAINING-LOCATION' | translate"
                      [dataSource]="googlePlaces"
                      valueExpr="description"
                      (onValueChanged)="getGooglePlaces($event)"
                      (onItemClick)="setLocationPlace($event)"
                      [readOnly]="isViewMode"
                      labelMode="floating"
                      stylingMode="outlined"
                      [validationErrors]="[
                        {
                          message:
                            'VALIDATIONS.TRAINING-LOCATION-REQUIRED' | translate
                        }
                      ]"
                      [validationStatus]="locationValidationStatus"
                    >
                    </dx-autocomplete>
                  </div>
                </div>
              </dxi-item>

              <dxi-item
                *ngIf="
                  trainingForm.trainingLocation.locationType === TrainingLocationType.Web
                "
                dataField="trainingLocation.location"
              >
                <dxo-label [text]="getTrainingLocationLabel"></dxo-label>
              </dxi-item>

              <dxi-item
                *ngIf="!editingTrainingId || !isIntegrationLocationType"
                dataField="trainingLocation.suffix"
                editorType="dxTextArea"
                [editorOptions]="{ height: 100 }"
              >
                <dxo-label [text]="getTrainingLocationDetailsLabel"></dxo-label>

                <dxi-validation-rule
                  *ngIf="isExternalEvent"
                  type="required"
                  [message]="'VALIDATIONS.EXTERNAL-EVENT-LOCATION-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>

              <dxi-item
                *ngIf="editingTrainingId && isIntegrationLocationType"
              >
                <div class="training-location-link-container">
                  <span class="training-location-link-label">
                    {{ getTrainingLocationDetailsLabel }}
                  </span>

                  <a
                    [href]="trainingForm.trainingLocation.suffix"
                    target="_blank"
                  >
                    {{ trainingForm.trainingLocation.suffix }}
                  </a>
                </div>
              </dxi-item>
            </dx-form>
          </div>

          <div class="col-md-12 col-lg-6">
            <div
              *ngIf="
                trainingForm.trainingLocation.locationType ===
                TrainingLocationType.Address
              "
            >
              <ng-container
                *ngIf="
                  trainingForm.trainingLocation.latitude &&
                  trainingForm.trainingLocation.longitude
                "
              >
                <app-google-maps
                  class="my-3"
                  [location]="trainingForm.trainingLocation"
                ></app-google-maps>
              </ng-container>
            </div>

            <div
              *ngIf="
                trainingForm.trainingLocation.locationType ===
                TrainingLocationType.GoToWebinar
              "
              class="training-location-image-container"
            >
              <img
                class="training-location-image"
                src="assets/img/gotowebinar-logo.jpg"
              />
            </div>

            <div
              *ngIf="
                trainingForm.trainingLocation.locationType ===
                TrainingLocationType.Webex
              "
              class="training-location-image-container"
            >
              <img
                class="training-location-image"
                src="assets/img/webex-logo.jpg"
              />
            </div>

            <div
              *ngIf="
                trainingForm.trainingLocation.locationType ===
                  TrainingLocationType.MsTeamsWebinar ||
                trainingForm.trainingLocation.locationType ===
                  TrainingLocationType.MsTeamsMeetings
              "
              class="training-location-image-container"
            >
              <img
                class="training-location-image"
                src="assets/img/teams-logo.png"
              />
            </div>
          </div>
        </div>
      </app-panel>
      <app-panel *ngIf="isViewMode && training?.files?.length">
        <div class="files-title">
          {{ "MANAGE-ELEARNING.OVERVIEW.AVAILABLE-FILES" | translate }} ({{
            training && training.files ? training.files.length : 0
          }})
        </div>
        <div
          class="full-height-list"
          *ngIf="training && training.files"
        >
          <div class="list-wrapper">
            <dx-list
              [dataSource]="training.files"
              class="striped-list"
            >
              <div *dxTemplate="let item of 'item'">
                <div class="file">
                  <div class="file-name">
                    <a [href]="item.fileUrl" target="_blank">
                      {{ item.fileName }}
                    </a>
                  </div>
                </div>
              </div>
            </dx-list>
          </div>
        </div>
      </app-panel>
      <app-panel
        *ngIf="
          !isViewMode &&
          trainingForm.trainingLocation.locationType == TrainingLocationType.Address
        "
        class="participation-question-panel"
        [title]="'TRAINING-QUESTIONNAIRE.FORM.TITLE' | translate"
      >
        <app-edit-training-participation-questions
          #participationQuestionEditorComponent
          [templates]="questionTemplates"
          [questions]="trainingForm.questions ?? []"
        ></app-edit-training-participation-questions>
      </app-panel>
      <app-panel
        *ngIf="
          isViewMode && training &&
          training.training.trainingLocation.type == TrainingLocationType.Address &&
          training.questions && training.questions.length !== 0
        "
        class="participation-question-answers-panel"
        [title]="'TRAINING-QUESTIONNAIRE.PARTICIPATION.QUESTIONNAIRE-RESPONSES' | translate"
      >
        <app-training-participation-answers
          *ngIf="allMembers"
          [allMembers]="allMembers"
          [questions]="training.questions"
        ></app-training-participation-answers>
      </app-panel>
    </div>
  </app-page>
</div>

<app-training-employee-popup
  #trainingEmployeeModal
  [trainingId]="editingTrainingId"
  [isClosedTraining]="training?.status === 2"
  [isFullyBookedTraining]="training?.isBookedUp ?? false"
  [isFromSubscribedSource]="training?.isFromSubscribedSource ?? false"
  [isPopupVisible]="isEmployeePopupVisible"
  [tab]="employeePopupTab"
  [openMembers]="openMembers"
  [acceptedMembers]="acceptedMembers"
  [declinedMembers]="declinedMembers"
  [requestedMembers]="requestedMembers"
  [queueMembers]="queueMembers"
  [completedMembers]="completedMembers"
  [channels]="channels"
  (onPopupClose)="onEmployeePopupClose()"
  (onReloadMembers)="onLoadMembers()"
/>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteTrainingModal"
  (submit)="onDeleteTrainingClick()"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>

<app-training-cancel-dialog
  [(showModal)]="showCancelTrainingModal"
  (submit)="onCancelTrainingClick($event)"
></app-training-cancel-dialog>

<app-training-start-date-changed-notification-dialog
  [(showModal)]="showStartDateChangedNotificationModal"
  (submit)="onStartDateChangedNotificationClick($event)"
></app-training-start-date-changed-notification-dialog>

<app-download-qr-code-modal
  [showModal]="showDownloadESignatureQRCodeModal"
  (showModalChange)="onCloseDownloadESignatureQRCodePopup()"
  [qrCodeImageUrl]="esignatureQRCodeImageUrl!"
></app-download-qr-code-modal>

<app-download-qr-code-modal
  [showModal]="showDownloadFeedbackQRCodeModal"
  (showModalChange)="onCloseDownloadFeedbackQRCodePopup()"
  [qrCodeImageUrl]="feedbackQRCodeImageUrl!"
  [showCopyButton]="true"
  [copyButtonText]="'TRAINING.FORM.COPY-FEEDBACK-LINK' | translate"
  (copyUrlClicked)="onCopyFeedbackLinkClick()"
></app-download-qr-code-modal>

@if(showCopyInvitationLinkModel && training){
  <app-copy-invitation-link-modal
    [(showModal)]="showCopyInvitationLinkModel"
    [trainingKey]="training.training.key"
  />
}

@if(showPreviewReportViewer) {
  <app-report-viewer-modal
    [title]="trainingForm.name"
    [(showModal)]="showPreviewReportViewer"
    [reportUrl]="reportUrl"
  ></app-report-viewer-modal>
}